import React from 'react';
import Icon from '../../../components/AppIcon';

const PipelineFunnel = ({ stages, loading, onStageClick }) => {
  const getStageColor = (index) => {
    const colors = [
      'bg-primary',
      'bg-secondary',
      'bg-accent',
      'bg-success'
    ];
    return colors?.[index % colors?.length];
  };

  const getStageWidth = (percentage) => {
    return `${Math.max(percentage, 20)}%`;
  };

  if (loading) {
    return (
      <div className="space-y-3 md:space-y-4">
        {[1, 2, 3, 4]?.map((i) => (
          <div key={i} className="h-16 md:h-20 bg-muted animate-pulse rounded-lg"></div>
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-3 md:space-y-4">
      {stages?.map((stage, index) => (
        <div
          key={stage?.id}
          className="cursor-pointer transition-smooth hover:scale-[1.02]"
          onClick={() => onStageClick && onStageClick(stage)}
        >
          <div className="flex items-center justify-between mb-1 md:mb-2">
            <span className="text-xs md:text-sm font-medium text-foreground">
              {stage?.name}
            </span>
            <span className="text-xs md:text-sm font-semibold text-foreground data-text">
              {stage?.count}
            </span>
          </div>
          
          <div className="relative h-12 md:h-14 bg-muted rounded-lg overflow-hidden">
            <div
              className={`absolute left-0 top-0 h-full ${getStageColor(index)} transition-all duration-500 flex items-center justify-between px-3 md:px-4`}
              style={{ width: getStageWidth(stage?.percentage) }}
            >
              <span className="text-xs md:text-sm font-medium text-white">
                {stage?.percentage}%
              </span>
              <Icon name="ChevronRight" size={16} color="#FFFFFF" className="md:w-5 md:h-5" />
            </div>
          </div>

          <div className="flex items-center justify-between mt-1 md:mt-2">
            <span className="text-xs text-muted-foreground">
              Valeur: {stage?.value}
            </span>
            <span className="text-xs text-muted-foreground">
              Taux: {stage?.conversionRate}%
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PipelineFunnel;